import React from 'react'

const DataTableHeader = ({ columns, columnSort, onColumnClick }) => {
    return (
        <tr className="table-header">
            {columns.map(({label, key}, index) => (
                <th key={index} onClick={() => onColumnClick(key)}>
                    <div className="table-header-sort" title={`Sort ${label}`}>
                        {label}
                        {columnSort.sortKey === key && <span className={`icon-keyboard_arrow_${columnSort.asc ? 'up' : 'down'}`} style={{marginLeft: '0.5em'}}></span>}
                    </div>
                </th>
            ))}
        </tr>
    )
}

export default DataTableHeader


// WEBPACK FOOTER //
// ./src/components/utils/DataTable/DataTableHeader.js